import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import t from '../../lib/I18n';

import StepHeader from '../serviceList/StepHeader';

class SteppableList extends React.PureComponent {

    static propTypes = {
        steps: PropTypes.arrayOf(PropTypes.shape({
            number: PropTypes.number,
            title: PropTypes.string,
            element: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.func
            ]),
        })).isRequired,
        currentStep: PropTypes.number.isRequired,
        customHeader: PropTypes.bool,
        headerElement: PropTypes.func
    };

    static defaultProps = {
        customHeader: false,
        headerElement: _.noop
    };

    getCurrentStep() {
        return _.find(this.props.steps, ['number', this.props.currentStep]);
    }

    render () {
        const step = this.getCurrentStep();
        const { customHeader, headerElement } = this.props;
        if (!step) {
            return null;
        }

        const Element = step.element;
        const TitleElement = customHeader ? headerElement :
              () => <StepHeader active
                          className="margin-bottom--sm"
                          label={ t(step.title) }
                          number={ step.number }/>;
        return (
            <div>
              <TitleElement />
              <Element />
            </div>
        );
    }
}

export default SteppableList;



// WEBPACK FOOTER //
// ./src/components/general/SteppableList.js